export default "__VITE_ASSET__CnXRqckt__"